import { useTheme } from '@mui/material/styles';
import { brandColors } from '../../theme';
export const useStyles = () => {
    const theme = useTheme();
    return {
        input: {
            borderRadius: theme.shape.borderRadius,
            position: 'relative',
            backgroundColor: theme.palette.common.white,
            border: `1px solid ${brandColors.tableBorder}`,
            width: '100%',
            padding: `${theme.spacing(1)} ${theme.spacing(1.5)}`,
            marginBottom: theme.spacing(1.5),
            '&:focus': {
                borderColor: theme.palette.primary.main,
            },
        },
        formControl: {
            width: '100%',
            '& input': {
                borderRadius: theme.shape.borderRadius,
                position: 'relative',
                backgroundColor: theme.palette.common.white,
                border: `1px solid ${brandColors.tableBorder}`,
                width: '100%',
                padding: `${theme.spacing(1)} ${theme.spacing(1.5)}`,
                '&:focus': {
                    borderColor: theme.palette.primary.main,
                },
            },
            '& textarea': {
                borderRadius: theme.shape.borderRadius,
                position: 'relative',
                backgroundColor: theme.palette.common.white,
                border: `1px solid ${brandColors.tableBorder}`,
                width: '100%',
                padding: `${theme.spacing(1)} ${theme.spacing(1.5)}`,
                marginBottom: theme.spacing(1.5),
                '&:focus': {
                    borderColor: theme.palette.primary.main,
                },
            },
        },
        standard: {
            '& input': {
                marginBottom: theme.spacing(1.5),
            },
        },
        error: {
            '& input': {
                borderColor: theme.palette.error.main,
            },
        },
        helpLabel: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1.5),
        },
        label: {
            fontWeight: 'bold',
        },
    };
};
